module.exports = __webpack_public_path__ + "img/school.db1427bf.png";